import script from "./detailsInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./detailsInfo.vue?vue&type=script&setup=true&lang=js"

import "./detailsInfo.vue?vue&type=style&index=0&id=2f1a1338&scoped=true&lang=css"

import exportComponent from "D:\\WorkJob\\SmartCarRace\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f1a1338"]])

export default __exports__